<template>
  <div>
    <div class="bg-white ml-1 rounded" style="width: 100%;">
      <div class="p-3 mb-5">
        <div v-if="!hasValidRoles" class="slide-left mb-3 p-3 rounded fs-3 bg-danger-subtle text-danger">
          <p class="text-center fw-bold">You don't
            have
            valid roles
            to
            continue. Please
            contact
            admin.
          </p>

        </div>
        <div class="row text-center" style="align-items: center;justify-content: start;">
          <HomeWidget :count="totalPages" class="bg-primary" font-awesome-icon-class="fa-solid fa-file"
                      name="Pages" route-to="/pages/all"></HomeWidget>
          <HomeWidget :count="totalServices" class="bg-success" font-awesome-icon-class="fa-brands fa-servicestack"
                      name="Services" route-to="/services/all"></HomeWidget>
          <HomeWidget :count="totalPosts" class="bg-info" font-awesome-icon-class="fa-solid fa-paste"
                      name="Posts" route-to="/posts/all"></HomeWidget>
          <HomeWidget :count="totalUsers" class="bg-warning" font-awesome-icon-class="fa-solid fa-user"
                      name="Users" route-to="/users/add"></HomeWidget>
          <HomeWidget :count="totalNotices" customStyles="background-color: #7f4dd1"
                      font-awesome-icon-class="fa-solid fa-circle-exclamation"
                      name="Notices" route-to="/notices/all"></HomeWidget>
          <HomeWidget :count="totalCirculars" customStyles="background-color: #e06678"
                      font-awesome-icon-class="fa-solid fa-briefcase"
                      href="http://123.200.20.20:7002/show-dtl-list" name="Circulars"></HomeWidget>
        </div>
      </div>
    </div>
    <div class="bg-white ml-1 rounded" style="width: 100%;">
      <div class="p-1 mb-5">
        <div class="row p-3">
          <div class="col-lg-6 col-md-8 border-right">
            <div class="rounded h-100">
              <h4>Recent Post Data</h4>
              <div class="table-responsive-sm">
                <table class="table table-striped ">
                  <thead class="thead-dark">
                  <tr>
                    <th scope="col">SL</th>
                    <th class="col-md-5">Title</th>
                    <th scope="col">Post Type</th>
                    <th scope="col">Publish Time</th>
                    <th scope="col">Expiry Time</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="(item1, index) in lastContants" :key="index">
                    <th scope="row">{{ index + 1 }}.</th>
                    <!--<td class="col-md-5">{{item1.title.substring(0,100)}}..</td>-->
                    <td :title="item1.title" class="col-md-5">{{
                        truncateStringDebug(item1.title,
                            100)
                      }}
                    </td>
                    <td v-if="item1.category_id == 1"><b>Post</b></td>
                    <td v-if="item1.category_id == 2"><b>Services</b></td>
                    <td v-if="item1.category_id == 3"><b>Laws</b></td>
                    <td v-if="item1.category_id == 4"><b>Notices</b></td>
                    <td v-if="item1.category_id == 5"><b>Pages</b></td>
                    <td v-if="item1.category_id == 6"><b>FAQs</b></td>
                    <td v-if="item1.category_id == 7"><b>Products</b></td>
                    <td v-if="item1.category_id == 8"><b>Management Info.</b></td>
                    <td>{{ formatDate(item1.publish_time) }}</td>
                    <td>{{ formatDate(item1.expiry_time) }}</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-4 ">
            <div>
              <h4>Total Data Chart</h4>
            </div>
            <div class="bg-white rounded h-90 d-flex  justify-content-center">
              <!--<div class="mt-5" style="width: 500px;height: 400px;">
                  <Pie :data="data" :options="options"/>
              </div>-->
              <div class="mt-5" style="width: 70%;height: 50vh;">
                <Doughnut :data="data" :options="options"/>
                <!--<h1 style>hi</h1>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dashboard from "@/services/dashboard.service";
import {ArcElement, Chart as ChartJS, Legend, Tooltip} from 'chart.js'
import {Doughnut} from 'vue-chartjs'
import moment from 'moment';
import HomeWidget from "@/components/HomeWidget.vue";

ChartJS.register(ArcElement, Tooltip, Legend)

export default {
  components: {
    /*Pie,*/
    Doughnut,
    HomeWidget,
  },
  setup() {
  },
  compatConfig: {MODE: 3},
  data() {
    return {
      hasValidRoles: true,
      data: {
        loading: false,
        labels: [],
        datasets: [{
          label: [],
          backgroundColor: [],
          data: []
        }],
        enableRtl: 'true',
      },
      options: [],
      totalPages: 0,
      totalPosts: 0,
      totalServices: 0,
      totalUsers: 0,
      totalNotices: 0,
      totalCirculars: 0,
      circularResponse: null,
      lastContants: [],
    };
  },
  async created() {
    const user = JSON.parse(localStorage.getItem('user'));
    this.hasValidRoles = user.data.user_role_id.length > 0 ? true : false;
    await this.getCicularData();
    this.getAllDashboardData();
  },
  methods: {
    truncateStringDebug(str, maxLength) {
      if (str.length > maxLength) {
        const truncated = str.substring(0, maxLength) + ' ...';
        return truncated;
      } else {
        return str;
      }
    },
    formatDate(date) {
      if (date != null) {
        return moment(date).format('DD-MMM-yyyy');
      } else {
        return "N/A";
      }

    },
    async getCicularData() {
      try {
        this.loading = true;
        const response = await dashboard.getCareerCircularData();
        this.loading = false;
        if (response.data) {
          this.totalCirculars = 0;
          response.data.data.forEach(circular => {
            const date = new Date(circular.po_end_date);
            if (date > Date.now() && circular.active_yn == "Active") {
              this.totalCirculars++;
            }
          });
          // this.totalCirculars = response.data.recordsTotal;
        }
      } catch (e) {
        this.loading = false;
      }
    },
    async getAllDashboardData() {
      try {
        this.loading = true;
        const response = await dashboard.getAllDashboardData();
        this.loading = false;
        if (response.data) {
          this.totalPages = response.data.pages;
          this.totalPosts = response.data.posts;
          this.totalServices = response.data.services;
          this.totalUsers = response.data.users;
          this.totalNotices = response.data.notices;
          this.lastContants = response.data.lastEvents;
          this.generateChartData();
        }
      } catch (e) {
        this.loading = false;
      }

    },
    generateChartData() {
      const labels = ["Pages", "Services", "Posts", "Users", "Notices", "Circulars"];
      this.data = {
        labels: labels,
        datasets: [
          {
            label: 'Total',
            backgroundColor: ['#4054D3', '#51E4A4', '#3BC8E1', '#f6c23e ', "#724DD1", "#e06678"],
            data: [this.totalPages, this.totalServices, this.totalPosts, this.totalUsers, this.totalNotices, this.totalCirculars]
          }
        ]
      };
      this.options = {
        responsive: true,
        maintainAspectRatio: false
      };
    },
  },
};
</script>
<style scoped>
tr.withBorder td {
  border: 1px solid black;
}

td {
  column-span: 1;
}

div.slide-left {
  width: 100%;
  overflow: hidden;
}

div.slide-left p {
  animation: slide-left 4s;
}

@keyframes slide-left {
  from {
    margin-left: 100%;
    width: 200%;
  }

  to {
    margin-left: 0%;
    width: 100%;
  }
}

</style>
